import React, { FC } from 'react';
import styles from './styles.module.css';
import { InfoTooltip, Modal } from '@clearcover/atlas';
import { BusinessUseModalContent } from './BusinessUseModalContent';

type VehicleBusinessLabelProps = {
  label: string;
};

export const VehicleBusinessLabel: FC<VehicleBusinessLabelProps> = ({
  label,
}) => (
  <div className={styles.VehicleBusinessLabel}>
    <span>{label}</span>
    <Modal
      onVisibilityChange={() => {}}
      variant="xl"
      toggle={openModal => (
        <button
          type="button"
          className={styles.businessUseModalButton}
          onClick={openModal}
        >
          <InfoTooltip size={16} tooltip="" />
        </button>
      )}
      children={closeModal => (
        <BusinessUseModalContent closeModal={closeModal} />
      )}
    />
  </div>
);
